import type { tableStoreCurrContextProps, tableStorePrevContextProps } from "../../@types/tables";

export const getNavType = () => {
    const nav = performance.getEntriesByType('navigation')[0] as PerformanceNavigationTiming | undefined;
    return nav?.type ?? null;
}

export const removeItemFromStorage = (storageKey: string, id?: string | null, sessionStorageFlag = false) => {
    const storage = sessionStorageFlag ? sessionStorage : localStorage;
    const storedValue = storage.getItem(storageKey);

    if (storedValue && id) {
        const parsedValue = JSON.parse(storedValue);

        if (!Array.isArray(parsedValue)) {
            storage.removeItem(storageKey);
            return;
        }

        const filteredValue = parsedValue.filter((item: { id: string; }) => item.id !== id);
        storage.setItem(storageKey, JSON.stringify(filteredValue));
        return
    }

    storage.removeItem(storageKey);
}

export const shouldClearScopedState = (
    prev: tableStorePrevContextProps | null,
    curr: tableStoreCurrContextProps,
    navType: string | null
) => {
    if (['back_forward', 'reload'].includes(navType ?? '') || !prev) {
        return false;
    }

    const childPaths = Array.isArray(prev.childPath)
        ? prev.childPath
        : prev.childPath
            ? [prev.childPath]
            : []

    if (prev.forceForget) {
        return true;
    }

    if (childPaths.length === 0) {
        return false;
    }

    const matchesChildPath = childPaths.some(
        (childPath) =>
            curr.path === childPath ||
            curr.path.includes(childPath)
    )

    if (matchesChildPath) {
        return false
    }

    if (prev.path && prev.path.startsWith(curr.path + '/')) {
        return false
    }

    return curr.path !== prev.path
}

export const roundPageLimit = (value: number) => {
    const roundedValue = Math.ceil(value / 10) * 10
    return Math.min(100, Math.max(10, roundedValue))
}
